/**
 * Campaign-banner dismissal, stored in a cookie rather than localStorage: the
 * feed is server-rendered, and only a cookie is readable on the server, which
 * lets the page drop a dismissed campaign before render. With localStorage the
 * visitor would see the banner they already closed flash in on every load.
 *
 * Isomorphic on purpose — the client writes, the server component reads.
 */

export const DISMISSED_CAMPAIGNS_COOKIE = "pu_dismissed_campaigns";

/** Six months — long enough that a dismissal outlives the campaign. */
const DISMISSAL_MAX_AGE_SECONDS = 60 * 60 * 24 * 180;

export function parseDismissedCampaigns(raw: string | undefined): string[] {
  if (!raw) return [];
  return raw
    .split(",")
    .map((id) => id.trim())
    .filter(Boolean);
}

/**
 * Read-modify-write, so dismissing one campaign never forgets another — the
 * cookie holds every id, not just the last.
 */
export function rememberCampaignDismissal(campaignId: string): void {
  const match = document.cookie.match(
    new RegExp(`(^| )${DISMISSED_CAMPAIGNS_COOKIE}=([^;]+)`)
  );
  const dismissed = parseDismissedCampaigns(
    match ? decodeURIComponent(match[2]) : undefined
  );
  if (dismissed.includes(campaignId)) return;

  const value = encodeURIComponent([...dismissed, campaignId].join(","));
  document.cookie = `${DISMISSED_CAMPAIGNS_COOKIE}=${value}; path=/; max-age=${DISMISSAL_MAX_AGE_SECONDS}; samesite=lax`;
}
